module.exports = __webpack_public_path__ + "files/2792be11e44ab082ee2bfb95044cf1ba.png";